var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { i18n, DataType } from '@easydata/core';
import { ExprTag } from '@easyquery/core';
import { domel, eqDragManager } from '@easydata/ui';
import { SimpleColumnRendererCP } from './simple_column_renderer';
import { browserUtils } from '../../../utils/browser_utils';
import { PopupMenu } from '../../../utils/popup_menu';
var CustomSqlColumnRendererCP = /** @class */ (function (_super) {
    __extends(CustomSqlColumnRendererCP, _super);
    function CustomSqlColumnRendererCP() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.dataTypeMenu = null;
        return _this;
    }
    CustomSqlColumnRendererCP.prototype.getClassesToAdd = function () {
        return this.cssPrefix + "-row " + this.cssPrefix + "-row-column-entattr" + _super.prototype.getClassesToAdd.call(this);
    };
    CustomSqlColumnRendererCP.prototype.renderColumnTypeButton = function () {
        var button = _super.prototype.renderColumnTypeButton.call(this);
        if (button) {
            button.firstElementChild.classList.add('aggregated');
            button.firstElementChild.setAttribute('title', i18n.getText('ButtonToSimple'));
        }
        return button;
    };
    CustomSqlColumnRendererCP.prototype.renderExpressionBlock = function () {
        var _this = this;
        if (!this.column.caption || this.column.caption == '') {
            this.column.caption = this.getDefaultColumnCaption();
        }
        var exprBlock = domel("div")
            .addClass(this.cssPrefix + "-expr-block")
            .addClass(browserUtils.getMobileCssClass())
            .toDOM();
        //Attribute element
        var builder = domel('div', exprBlock)
            .addClass(this.cssPrefix + "-colelement", this.cssPrefix + "-attrelement")
            .addClass(browserUtils.getMobileCssClass());
        if (this.isEditable()) {
            builder
                .addChild('a', function (b) { return b
                .attr('href', 'javascript:void(0)')
                .title(_this.column.caption)
                .text(_this.column.caption)
                .on('touchstart click', function (ev) {
                ev.stopPropagation();
                var element = ev.target;
                var inputEl = element.parentElement.querySelector('input');
                if (inputEl) {
                    element.style.display = 'none';
                    inputEl.style.removeProperty('display');
                    inputEl.style.width = "100%";
                    inputEl.focus();
                    _this.element.setAttribute(eqDragManager.DRAG_DISABLED_ATTR, '');
                }
            }); } //TO DO:add localization and input field
            )
                .addChild('input', function (b) { return b
                .hide()
                .value(_this.column.expr.sql)
                .on('blur keydown', function (ev) {
                var isEndEvent = false;
                var save = true;
                if (ev instanceof KeyboardEvent) {
                    // Enter
                    if (ev.keyCode === 13) {
                        isEndEvent = true;
                        //ESC
                    }
                    else if (ev.keyCode === 27) {
                        isEndEvent = true;
                        save = false;
                    }
                }
                else if (ev instanceof FocusEvent) {
                    isEndEvent = true;
                }
                if (isEndEvent) {
                    var inputEl = ev.target;
                    var aEl = inputEl.parentElement.querySelector('a');
                    if (aEl) {
                        aEl.style.removeProperty('display');
                        inputEl.style.display = 'none';
                    }
                    if (save && _this.column.expr.sql !== inputEl.value) {
                        _this.column.expr.sql = inputEl.value;
                        _this.fireColumnChanged();
                    }
                    else {
                        inputEl.value = _this.column.expr.sql;
                    }
                    _this.element.removeAttribute(eqDragManager.DRAG_DISABLED_ATTR);
                }
            }); });
        }
        else {
            builder
                .addChild('span', function (b) {
                b.text(_this.column.caption)
                    .title(_this.column.caption);
            });
        }
        // Colon element
        builder = domel('div', exprBlock)
            .addClass(this.cssPrefix + "-colelement")
            .addChild('span', function (b) {
            b.text(':')
                .title(':');
        });
        // DataType element
        builder = domel('div', exprBlock)
            .addClass(this.cssPrefix + "-colelement", this.cssPrefix + "-attrelement")
            .addClass(browserUtils.getMobileCssClass());
        if (this.isEditable()) {
            this.createDataTypeMenu();
            builder
                .addChild('a', function (dataTypeLink) { return dataTypeLink
                .attr('href', 'javascript:void(0)')
                .title(DataType[_this.column.expr.dataType])
                .text(DataType[_this.column.expr.dataType])
                .on('touchstart click', function (ev) {
                ev.stopPropagation();
                _this.dataTypeMenu.showMenu({
                    anchor: dataTypeLink.toDOM(),
                    selectedIds: null,
                    itemSelectedCallback: function (data, items) {
                        _this.column.expr.dataType = data.id;
                        _this.fireColumnChanged();
                    }
                });
            }); });
        }
        else {
            this.column.expr.dataType;
            builder
                .addChild('span', function (b) {
                b.text(DataType[_this.column.expr.dataType])
                    .title(DataType[_this.column.expr.dataType]);
            });
        }
        return exprBlock;
    };
    CustomSqlColumnRendererCP.prototype.changeTypeToSimple = function () {
        var query = this.column.getQuery();
        query.changeColumnType(this.column, ExprTag.EntityAttribute);
        this.fireColumnChanged();
    };
    CustomSqlColumnRendererCP.prototype.getDefaultColumnCaption = function () {
        return "Custom SQL Column";
    };
    CustomSqlColumnRendererCP.prototype.getDefaultValue = function () {
        return this.column.expr.sql;
    };
    CustomSqlColumnRendererCP.prototype.getUIS = function () {
        return true;
    };
    CustomSqlColumnRendererCP.prototype.changeTypeHandler = function (ev) {
        this.changeTypeToSimple();
    };
    CustomSqlColumnRendererCP.prototype.processExtraButtonMenuItems = function (action, evt) {
        this.changeTypeToSimple();
        return true;
    };
    CustomSqlColumnRendererCP.prototype.createFunctionMenu = function () {
        // Nothing TO DO
    };
    CustomSqlColumnRendererCP.prototype.getExtraButtonMenuItems = function () {
        return [{
                id: '__group',
                text: i18n.getText('ColTypeGroup'),
                items: [{
                        id: 'type',
                        text: i18n.getText('ColTypeSimple')
                    }]
            }];
    };
    CustomSqlColumnRendererCP.prototype.createDataTypeMenu = function () {
        var items = [];
        for (var typeItem in DataType) {
            if (!isNaN(Number(typeItem))) {
                var item = {
                    id: typeItem,
                    text: DataType[typeItem]
                };
                items.push(item);
            }
        }
        var menuId = this.column.id;
        if (menuId) {
            menuId += '-DataTypeMenu';
        }
        var menuOptions = {
            items: items,
            id: menuId,
            searchBoxAlwaysShown: false,
            domWriteItemsId: true
        };
        this.dataTypeMenu = new PopupMenu(menuOptions);
    };
    return CustomSqlColumnRendererCP;
}(SimpleColumnRendererCP));
export { CustomSqlColumnRendererCP };
//# sourceMappingURL=customsql_column_renderer.js.map